<template>
  <router-link :to="route">
    <div :class="tallClass(decodeURI(imageUrl))" v-if="imageUrl !== null">
      <img :src="decodeURI(imageUrl)">
    </div>
    <div class="thumb-box" v-else>
      <img :src="null">
    </div>
    <div :class="{ house_about: true, house_linktxt: link, house_linktxt_rental: property.type !== 'business' }">
      <h3>{{property.property_name}}</h3>
      <template v-if="property.type === 'business'">
        <dl>
          <dt>{{$t('property_price')}}</dt>
          <dd>{{formatPrice(property.property_price)}}</dd>
        </dl>
        <dl>
          <dt>{{($t('building_price'))}}</dt>
          <dd>{{formatPrice(property.building_price)}}</dd>
        </dl>
        <dl v-if="!isEmpty(property.land_price)">
          <dt>{{$t('land_price')}}</dt>
          <dd>{{formatPrice(property.land_price)}}</dd>
        </dl>
        <dl v-if="!isEmpty(property.yields)">
          <dt>{{$t('yields')}}</dt>
          <dd>{{`${property.yields}%`}}</dd>
        </dl>
      </template>
      <template v-else>
        <dl>
          <dt>{{$t('rent')}}</dt>
          <dd>{{property.rent}}</dd>
          <template v-if="!isEmpty(property.administrative_fee)">
            <dt>{{$t('administrative_fee')}}</dt>
            <dd>{{property.administrative_fee}}</dd>
          </template>
        </dl>
        <dl v-if="!isEmpty(property.security_deposit)">
          <dt>{{$t('security_deposit')}}</dt>
          <dd>{{property.security_deposit}}</dd>
        </dl>
        <dl v-if="!isEmpty(property.key_money)">
          <dt>{{$t('key_money')}}</dt>
          <dd>{{property.key_money}}</dd>
        </dl>
        <dl v-if="!isEmpty(property.intermediary_charge)">
          <dt>{{$t('intermediary_charge')}}</dt>
          <dd>{{property.intermediary_charge}}</dd>
        </dl>
      </template>
      <div class="cat-box">
        <span class="format_cat">{{$t(property.type)}}</span>
        <span class="article_cat" v-if="property.property_category">{{$t(property.property_category)}}</span>
        <span class="status_cat" v-if="property.report_status">{{$t(property.report_status)}}</span>
      </div>
    </div>
  </router-link>
</template>
<script>
export default {
  props: {
    item: {
      type: [Object, Array],
      required: true
    },
    link: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    route: function () {
      const id = this.property.property_id ?? this.property.id
      if (this.property.type === 'business') {
        return {
          name: 'Client Property Detail',
          params: {
            lang: this.$route.params.lang,
            id: id
          }
        }
      } else {
        return {
          name: 'rental-property-detail',
          params: {
            lang: this.$route.params.lang,
            type: this.property.type.replace('rental-', '') + '-property-detail',
            id: id
          }
        }
      }
    },
    imageUrl: function () {
      if (this.property.image) {
        return this.property.image.url
      } else if (this.property.properties_images && this.property.properties_images[0] && this.property.properties_images[0].type === 'mainImage') {
        return this.property.properties_images[0].images.url
      }
      return null
    },
    property: function () {
      if (Array.isArray(this.item)) {
        return this.item[0]
      }
      return this.item
    }
  },
  methods: {
    formatPrice: function (price, withBracket = false) {
      const p = Number(price)

      if (Number.isNaN(p) || p === 0) return ''

      const priceString = p.toLocaleString() + ' ' + this.$t('yen')
      return withBracket ? `（${priceString}）` : priceString
    },
    tallClass: function (image) {
      let img = null
      img = new Image()
      img.src = image
      if (img.height > img.width) {
        return 'thumb-box tall'
      } else {
        return 'thumb-box'
      }
    },
    isEmpty: function (value) {
      if (!value) return true

      switch (typeof value) {
        case 'string':
          return value === '' || value === '0'
        case 'number':
          return value === 0
        default:
          return false
      }
    }
  }
}
</script>
